import { SearchState } from '../../../models';
import { GETTERS_KEYS } from '../../store.const';
import { RootStoreState } from '../../store.interfaces';
import { SEARCH_GETTERS_KEYS } from '../search.const';
import { SearchGetter } from '../search.interfaces';

export class RemainingFacetsGetter implements SearchGetter {
  getters = {
    /* Returns from the state of facets which ones are not explicitly configured inside a group */
    [SEARCH_GETTERS_KEYS.remainingFacets]: (state: SearchState, getters: any, rootState: RootStoreState, rootGetters: any): string[] => {
      const configuredFacets: Set<string> = rootGetters[GETTERS_KEYS.config.configuredFacets];
      return Object.keys(state.facets).reduce((remainingFacets, facetName) => {
        if (!configuredFacets.has(facetName)) {
          remainingFacets.push(facetName);
        }
        return remainingFacets;
      }, []);
    }
  };
}
